import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    hiddenField: {
        display: 'none',
    },
    bottomTextWrapper: {
        paddingTop: theme.spacing(2),
    },
    forgotPasswordWrapper: {
        paddingTop: theme.spacing(1),
    },
    submitButtonWrapper: {
        paddingTop: theme.spacing(3),
        width: '75%',
        margin: '0 auto',
        boxSizing: 'border-box',
    },
    alertWrapper: {
        bottom: 0,
        padding: theme.spacing(3),
        position: 'absolute',
        right: 0,
        zIndex: 1500,
        maxWidth: '545px',
    },
}));
